<mat-card [class.view-mode]="data.mode !== 'Edit' && data.mode !== 'Add'">
	<mat-card-header>
		<mat-card-title>
			<button mat-button *ngIf="isLoading" disabled="true">
				<mat-icon>
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Loading
			</button>
			<div mat-dialog-title class="minus-mat-dialog-title-margin" *ngIf="!isLoading">
				{{data.mode === 'Add' ? 'Adding': data.mode === 'Edit' ? 'Editing': 'Viewing'}} Service
			</div>
			<button class="close-button" mat-mini-fab [mat-dialog-close]="false" *ngIf="!isLoading">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content *ngIf="!isLoading">
		<div>
			<form [formGroup]="form" (ngSubmit)="submit()" #serviceAdministrationForm="ngForm">
				<div class="row gx-0">
					<div class="col-lg-6 padding-horizontal-md edit-service-administration-border-right">

						<div class="row gx-0">

							<div class="col-lg-12">

								<region-dropdown-two-way class="w-100" [(selectedRegion)]="chosenRegion"
									[customLabel]="'1. Region'" [isMultiple]="false" [required]="true"
									[disabled]="data.mode !== 'Add'">
								</region-dropdown-two-way>

							</div>

							<div class="col-lg-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										2. Service Name
									</mat-label>
									<input matInput id="name" name="name" type="string" formControlName="name" />
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'ServiceAdministration_ServiceName'"></help-text-btn>
							</div>

							<div class="col-lg-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										3. Service Description
									</mat-label>
									<textarea matInput id="description" name="description" type="string"
										formControlName="description" rows="4">
							</textarea>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'ServiceAdministration_ServiceDescription'"></help-text-btn>
							</div>

							<div class="col-lg-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										4. Local Code Number
									</mat-label>
									<input matInput id="localCodeNumber" name="localCodeNumber" type="number"
										formControlName="serviceCode" />
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'ServiceAdministration_LocalCodeNumber'"></help-text-btn>
							</div>

							<div class="col-lg-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										5. State Code Number
									</mat-label>
									<mat-select formControlName="federalCode"
										(selectionChange)="stateServiceChange($event)">
										<mat-option>Select State Code (if applicable)</mat-option>
										<mat-option *ngFor="let stateService of stateServices" [value]="stateService"
											[disabled]="!stateService.ACTIVE" [hidden]="!stateService.VISIBLE">
											{{ stateService.SERVICE_CODE }} - {{stateService.SERVICE_NAME}}
										</mat-option>
									</mat-select>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'ServiceAdministration_StateCodeNumber'"></help-text-btn>
							</div>

							<div class="col-lg-12 inline">
								<mat-form-field class="w-100">
									<mat-label>
										6. Measurable Program Objective
									</mat-label>
									<mat-select formControlName="mpo" (selectionChange)="mpoChange($event)">
										<mat-option>Select State Code (if applicable)</mat-option>
										<mat-option *ngFor="let mpo of measurableProgramObjectives" [value]="mpo"
											[disabled]="!mpo.ACTIVE" [hidden]="!mpo.VISIBLE">
											{{mpo.NAME}}
										</mat-option>
									</mat-select>
								</mat-form-field>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'ServiceAdministration_MeasurableProgramObjective'"></help-text-btn>
							</div>

							<div class="col-lg-12 inline">
								<div>
									7. SDP Components
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_SSDPComponents'"></help-text-btn>
								</div>
							</div>
							<div class="row">
								<mat-checkbox [color]="'primary'" class="col-lg-12"
									[formControlName]="ssdpComponent.NAME!" *ngFor="let ssdpComponent of ssdpComponents"
									[hidden]="!ssdpComponent.VISIBLE">
									{{ssdpComponent.NAME}}
								</mat-checkbox>
							</div>
						</div>

					</div>
					<div class="col-lg-6 padding-horizontal-md">

						<div class="row">
							<div class="col-lg-12">
								<div>
									8. Require Service Hours
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_ServiceHours'"></help-text-btn>
								</div>
							</div>
							<mat-radio-group aria-label="Require Service Hours" formControlName="serviceHour">
								<mat-radio-button [color]="'primary'" [value]="serviceHour.NAME"
									*ngFor="let serviceHour of serviceHours">{{serviceHour.NAME}}</mat-radio-button>
							</mat-radio-group>

							<div class="col-lg-12">
								<div>
									9. Federal Category *
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_FederalCategory'"></help-text-btn>
								</div>
							</div>
							<div class="col-lg-12">
								<mat-radio-group aria-label="Federal Category" formControlName="federalCategory">
									<div *ngFor="let federalCategory of federalCategories">
										<div *ngIf="!federalCategory.CHILD_SERVICE_TYPES">
											<mat-radio-button [color]="'primary'" [value]="federalCategory"
												(change)="federalCategoryChange(federalCategory.PARENT_SERVICE_TYPES!)"
												[disabled]="!federalCategory.ENABLED">
												{{federalCategory.PARENT_SERVICE_TYPES?.TYPE}}
											</mat-radio-button>
										</div>
										<div class="padding-left-md" *ngIf="federalCategory.CHILD_SERVICE_TYPES">
											<mat-checkbox [color]="'primary'" [disabled]="!federalCategory.ENABLED"
												[formControlName]="federalCategory.CHILD_SERVICE_TYPES.TYPE + '|' + federalCategory.CHILD_SERVICE_TYPES.ID!.toString()"
												(change)="federalCategoryChange(federalCategory.PARENT_SERVICE_TYPES!, federalCategory.CHILD_SERVICE_TYPES,$event)">
												{{ federalCategory.CHILD_SERVICE_TYPES?.TYPE }}
											</mat-checkbox>
										</div>
									</div>
								</mat-radio-group>
							</div>

							<div class="col-lg-12">
								<div>
									10. Service Category *
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_ServiceCategory'"></help-text-btn>
								</div>
							</div>
							<mat-radio-group aria-label="Service Category" formControlName="serviceCategory">
								<mat-radio-button [color]="'primary'" [value]="serviceCategory.CATEGORY"
									*ngFor="let serviceCategory of serviceCategories">{{serviceCategory.CATEGORY}}
								</mat-radio-button>
							</mat-radio-group>

							<div class="col-lg-12">
								<div>
									11. Provided By *
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_ProvidedBy'"></help-text-btn>
								</div>
							</div>
							<mat-radio-group aria-label="Service Provider" formControlName="serviceProvider">
								<mat-radio-button [color]="'primary'" [value]="serviceProvider.TYPE"
									*ngFor="let serviceProvider of serviceProviders">{{serviceProvider.TYPE}}
								</mat-radio-button>
							</mat-radio-group>

							<div class="col-lg-12 inline">
								<grade-dropdown class="w-100" [(chosenGrades)]="grades" [isMultiple]="true"
									[label]="'12. Grade Range'" [required]="true" [disabled]="gradesDisabled"
									(gradeEvent)="gradeEventEmitter($event)">
								</grade-dropdown>
								<help-text-btn class="align-help-text-btn"
									[helpTextId]="'ServiceAdministration_Grade'"></help-text-btn>
							</div>

							<div class="col-lg-12">
								<div>
									13. Service Periods *
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_ServicePeriod'"></help-text-btn>
								</div>
							</div>
							<div class="col-lg-12">
								<mat-checkbox [color]="'primary'" [formControlName]="enrollmentPeriod.PERIOD!"
									*ngFor="let enrollmentPeriod of enrollmentPeriods">
									{{enrollmentPeriod.PERIOD}}
								</mat-checkbox>
							</div>

							<div class="col-lg-12">
								<div>
									14. Service Status *
									<help-text-btn class="align-help-text-btn"
										[helpTextId]="'ServiceAdministration_ServiceStatus'"></help-text-btn>
								</div>
							</div>
							<mat-radio-group aria-label="Service Status" formControlName="serviceStatus">
								<mat-radio-button [color]="'primary'" [value]="partyServiceStatusType.TYPE"
									*ngFor="let partyServiceStatusType of partyServiceStatusTypes">
									{{partyServiceStatusType.TYPE}}
								</mat-radio-button>
							</mat-radio-group>

						</div>
					</div>
				</div>
			</form>
		</div>

		<hr />

		<div class="row">
			<div class="col-lg-12" *ngIf="data.mode === 'Edit' && tableDataSource">
				<div *ngIf="tableDataSource.filteredData.length <= 0">
					No Changes
				</div>

				<div class="margin-top-sm table-responsive" *ngIf="tableDataSource.filteredData.length > 0">
					<h3>Current Changes ({{tableDataSource.filteredData.length}})</h3>
					<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1" matSort>

						<ng-container matColumnDef="CHANGED_FIELD">
							<mat-header-cell *matHeaderCellDef> Field </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.CHANGED_FIELD}} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="VALUE">
							<mat-header-cell *matHeaderCellDef> Previous Value </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.VALUE}} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="CHANGED_VALUE">
							<mat-header-cell *matHeaderCellDef> New Value </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.CHANGED_VALUE}} </mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>
				</div>

				<hr />
			</div>
			<div class="col-lg-12" *ngIf="data.mode !== 'View'">
				<div class="row">
					<div>
						* Required fields
					</div>
					<div class="margin-top-sm">
						<button mat-raised-button type="submit" color="primary" *ngIf="data.mode === 'Add'"
							(click)="serviceAdministrationForm.ngSubmit.emit()"
							[disabled]="this.form.invalid || this.grades.length <= 0 || submitting">
							Create
							<mat-icon *ngIf="submitting">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
						</button>
						<button mat-raised-button type="submit" color="primary" *ngIf="data.mode === 'Edit'"
							(click)="serviceAdministrationForm.ngSubmit.emit()"
							[disabled]="this.form.invalid || this.grades.length <= 0 || submitting">
							Save
							<mat-icon *ngIf="submitting">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
						</button>
					</div>
				</div>
				<div>
					<app-msg [msg]="msg" *ngIf="showMsg"></app-msg>
				</div>
			</div>
			<div class="col-lg-12 margin-top-sm" *ngIf="data.serviceAdministrationId">
				<tracking-history [formName]="'CreateService'"
					[formID]="data.serviceAdministrationId"></tracking-history>
			</div>
		</div>
	</mat-card-content>
</mat-card>